export default __webpack_public_path__ + "static/media/img14.c188bfd8.svg";